export default __webpack_public_path__ + "static/media/Ass 12.198a0417.png";